import { getAllLocales, getLocale, setLocale } from '@umijs/max';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import React from 'react';
import { TranslationOutlined } from '@ant-design/icons';
import { CheckGlyph } from '@/pages/user/authIcons';
import { useMenuStyles } from './menuStyles';

export type SiderTheme = 'light' | 'dark';

/** 语言的自称，不做翻译 —— 找中文入口的人看不懂 "Chinese"。 */
const LABELS: Record<string, string> = {
  'zh-CN': '简体中文',
  'en-US': 'English',
};

/**
 * 语言切换。
 *
 * 没有用 umi 自带的 SelectLang：它带 US / CN 的国旗色块，和这套界面的
 * 语言对不上。图标沿用原来那个「文A」，只把面板样式统一到账号下拉那套。
 */
export const SelectLang: React.FC = () => {
  const { styles } = useMenuStyles();
  const current = getLocale();
  const locales = getAllLocales().filter((locale) => LABELS[locale]);

  if (locales.length < 2) {
    return null;
  }

  const items: MenuProps['items'] = locales.map((locale) => ({
    key: locale,
    label: (
      <span className={styles.langItem}>
        {LABELS[locale]}
        {locale === current ? <CheckGlyph className={styles.langTick} /> : null}
      </span>
    ),
  }));

  return (
    <Dropdown
      overlayClassName={styles.panel}
      placement="bottomRight"
      menu={{
        items,
        selectedKeys: [current],
        // 第二个参数是「是否整页刷新」。传 false，切语言不会把
        // 已经填了一半的登录表单冲掉。
        onClick: ({ key }) => setLocale(key, false),
      }}
    >
      <button type="button" className={styles.langTrigger} aria-label={LABELS[current] ?? current}>
        <TranslationOutlined style={{ fontSize: 17 }} />
      </button>
    </Dropdown>
  );
};
